// temporary structure of the heading

import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import { useAuth } from "../../contexts/authContext";
import { getForms, getProject, getSession } from "../../selectors/appSelectors";
import "./header.scss";
import logoutIco from "../../utils/images/logout.png";
import { Tooltip } from "react-tippy";
import { Button } from "react-bootstrap";
import { MdDevices } from "react-icons/md";
import { GiTeacher } from "react-icons/gi";
import { AppState } from "../../reducers/rootReducer";
import elementService from "../../services/elementService";
import { ActionCreators as UndoActionCreators } from "redux-undo";
import { IoArrowRedoSharp, IoArrowUndoSharp } from "react-icons/io5";
import { Modes } from "../../utils/constants";
import produce from "immer";
import { setSession } from "../../actions/sessionListAction";
const HeaderComponent: FC = () => {
  const { authData, logout } = useAuth();
  const sessionState = useSelector((state: AppState) => state.session);
  const projectState = useSelector(getProject);
  const formState = useSelector(getForms);
  const history = useHistory();
  const dispatch = useDispatch();
  const elements = useSelector((state: AppState) => state.elementList);
  const handleLogOut = async () => {
    await logout();
    history.push("/logout");
  };

  const selectedFormAndProject = () => {
    const selectedProject = projectState.filter((project) => {
      return project.id === sessionState.selectedProjectId;
    });
    const selectedForm = formState.filter((form) => {
      return form.id === sessionState.selectedFormId;
    });
    console.log(selectedForm);
    const selectedGroup =
      selectedProject.length !== 0 && selectedForm.length !== 0
        ? selectedProject[0].groups.filter((group) => {
            return selectedForm[0].groupId === group.id;
          })
        : [];
    if (selectedProject.length === 0 || selectedForm.length === 0) {
      return "";
    } else {
      return `${selectedProject[0].name} : ${
        selectedGroup.length === 0 ? "Default Group" : selectedGroup[0].name
      } : ${selectedForm[0].name}`;
    }
  };

  const previewForm = () => {
    window.open(
      `preview/preview-render/${sessionState.selectedFormId}`,
      "_blank"
    );
  };

  const undoRedo = (type: string) => {
    if (type == "UNDO") {
      if (elements.past.length > 1) {
        elementService.undoRedoElements(
          elements.past[elements.past.length - 1]
        );
        dispatch(UndoActionCreators.undo());
      }
    } else {
      elementService.undoRedoElements(elements.future[0]);
      dispatch(UndoActionCreators.redo());
    }
  };

  return (
    <>
      {authData && (
        <nav className="navbar navbar-expand-lg navbar-dark theme-dark">
          <div className="navbar-brand">
            <Link
              style={{ color: "white" }}
              to="/home"
              onClick={() => {
                let newSessionState = produce(sessionState, (draft) => {
                  draft.selectedMode = Modes.WORKING;
                });
                dispatch(setSession(newSessionState));
              }}
            >
              EzyBlu
            </Link>
          </div>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">
              <li className="nav-item mt-1">
                <Tooltip title="Navigate To Home">
                  <Link
                    className="home-link btn opasity"
                    to="/home"
                    onClick={() => {
                      let newSessionState = produce(sessionState, (draft) => {
                        draft.selectedMode = Modes.WORKING;
                      });
                      dispatch(setSession(newSessionState));
                    }}
                  ></Link>
                </Tooltip>
              </li>
              {sessionState.selectedMode === Modes.WORKING && (
                <>
                  <li className="nav-item ml-2 mt-2">
                    <Tooltip title="Undo">
                      <IoArrowUndoSharp
                        size={18}
                        className="opasity"
                        onClick={() => {
                          undoRedo("UNDO");
                        }}
                      />
                    </Tooltip>
                  </li>
                  <li className="nav-item ml-2 mt-2">
                    <Tooltip title="Redo">
                      <IoArrowRedoSharp
                        size={18}
                        className="opasity"
                        onClick={() => {
                          undoRedo("REDO");
                        }}
                      />
                    </Tooltip>
                  </li>
                  <li className="nav-item ml-2 mt-1">
                    <Tooltip title="Navigate To Prototype">
                      <Link
                        className="prototype-link btn opasity"
                        to={`/home/prototype/create/${sessionState.selectedProjectId}`}
                        onClick={() => {
                          let newSessionState = produce(
                            sessionState,
                            (draft) => {
                              draft.selectedMode = Modes.PROTOTYPE;
                            }
                          );
                          dispatch(setSession(newSessionState));
                        }}
                      ></Link>
                    </Tooltip>
                  </li>
                  <li className="nav-item ml-2 mt-2">
                    <Tooltip title="Preview">
                      <MdDevices
                        size={18}
                        className="opasity"
                        onClick={() => {
                          previewForm();
                        }}
                      />
                    </Tooltip>
                  </li>
                </>
              )}
              <li className="nav-item ml-2 mt-2">
                <Tooltip title="Video Tutorials">
                  <GiTeacher
                    size={18}
                    className="opasity"
                    onClick={() => {
                      window.open(
                        "https://www.youtube.com/watch?v=O_9u1P5YjVc&list=PL4cUxeGkcC9joIM91nLzd_qaH_AimmdAR",
                        "_blank"
                      );
                    }}
                  />
                </Tooltip>
              </li>
            </ul>
            {sessionState.selectedMode === Modes.WORKING && (
              <div className="nav-center">{selectedFormAndProject()}</div>
            )}
            {sessionState.selectedMode === Modes.PROTOTYPE && (
              <div className="nav-center">Prototype Creation</div>
            )}
            <Tooltip title="Logout">
              <button
                className="btn logout-btn my-2 my-sm-0 opasity"
                type="button"
                onClick={() => {
                  handleLogOut();
                }}
              ></button>
            </Tooltip>
          </div>
        </nav>
      )}
    </>
  );
};

export default HeaderComponent;
